import React, { useState, useEffect, useRef } from "react";
import ViewworkbookHeader2 from "./Components/ViewworkbookHeader2";
import ViewWBCharts from "./Components/ViewWBCharts";
import LibraryFolderPaths from "../LibraryFolderPaths";
import useAuth from "../../hooks/useAuth";
import { conditionForEditWB } from "../smallFunction/conditionForEditWB";
import { IoArrowBackOutline } from "react-icons/io5";
import { useNavigate, useSearchParams } from "react-router-dom";
import DropDownComp from "../../components/DropDownComp";
import { ImHome } from "react-icons/im";
import { useGetWorkbookQuery } from "../reduxworkbook/dataApiSlice";
import { useDispatch } from "react-redux";
import { setWorkbookData } from "../reduxworkbook/WorkbookSlice";
import SubscribeModal from "./Components/SubscribeModal";
import { useMyContext } from "../../MyContext";
import DownloadDataModal from "../DownloadDataModal";
import FilterItem from "../reduxworkbook/dashboard/FilterItem";
import LoadingIndicator from "../../components/BasicComponents/LoadingIndicator";
import ViewworkbookHeader1 from "./Components/ViewworkbookHeader1";
const GRID_COLUMNS = 24;
export default function ViewWorkbook() {
  const GRID_COLUMNS = 24;
  const { username, roles } = useAuth();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const droppableAreaRef = useRef(null);
  const itemRef = useRef(null);
  const buttonRef = useRef(null);
  const { callFunction } = useMyContext();
  const sheetId = searchParams.get("sheetid");
  const workbookId = searchParams.get("workbookid");
  let filterBar = false;
  if (searchParams.get("filterbar")) {
    console.log(searchParams.get("filterbar"));
    if (searchParams.get("filterbar") === "true") {
      filterBar = true;
    } else if (searchParams.get("filterbar") === "false") {
      filterBar = false;
    }
  }
  const [subscribeModal, setSubscribeModal] = useState(false);
  const [gridSize, setGridSize] = useState(25);
  const [filterSideBar, setFilterSideBar] = useState(filterBar || false);
  const [currentSheet, setCurrentSheet] = useState(null);
  const [downloadDataModal, setDownloadDataModal] = useState(false);

  const handleCallFunction = (receivedId) => {
    console.log(receivedId);    
    callFunction(receivedId);
  };
  const snapToGrid = (value, gridSize) => {
    console.log(value);
    const convertedPixels = Math.max(0, value * gridSize);
    return convertedPixels;
  };

  const handleDownloadDataModal = () => {
    setDownloadDataModal(true);
    // handleCallFunction()
  };
  const {
    data: workbookData,
    isError: isWorkbookError,
    isLoading: isWorkbookLoading,
    isSuccess: isWorkbookSuccess,
    error: workbookError,
  } = useGetWorkbookQuery(workbookId);

  const wbCreatedBy =
    workbookData !== undefined
      ? workbookData.createdBy
        ? workbookData.createdBy
        : "createdBy is not existed"
      : "workbook data is undefined";
  console.log(wbCreatedBy);

  const isEditButtonVisible = conditionForEditWB({
    username,
    roles,
    wbCreatedBy,
  });
  console.log(window.location.pathname);

  useEffect(() => {
    if (workbookData !== undefined) {
      dispatch(setWorkbookData(workbookData));
      console.log(workbookData);
    } else {
      console.error("workbook data is undefined");
    }
  }, [workbookId, workbookData]);

  useEffect(() => {
    if (workbookData !== undefined) {
      if (workbookData?.parentFolderId) {
        sessionStorage.setItem("folderId", workbookData?.parentFolderId);
      }

      if (sheetId) {
        const sheet = workbookData.sheets.find(
          (sheet) => sheet.ID === sheetId
        );
        console.log(sheet);
        if (sheet) {
          if (
            sheet.sheetType === "dashboard" &&
            sheet.SheetsArray.length > 0
          ) {
            setCurrentSheet({
              Sheetid: sheet.ID,
              SheetName: sheet.SheetName,
              SheetType: sheet.sheetType,
              SheetsArray: sheet.SheetsArray,
            });
          } else {
            setCurrentSheet({
              Sheetid: sheet.ID,
              SheetName: sheet.SheetName,
              SheetType: sheet.sheetType,
              SheetVizType: sheet.VizType,
              SheetDataSourceID: sheet.dataSourceID,
            });
          }
        }
      } else {
        // sheetId is undefined or null so selectedSheet 
        const selectedSheet = workbookData.sheets.find(
          (sheet) => sheet.ID === sheetId
        );
        setCurrentSheet({
          Sheetid: selectedSheet.ID,
          SheetName: selectedSheet.SheetName,
          SheetType: selectedSheet.sheetType,
          SheetVizType: selectedSheet.VizType,
          SheetDataSourceID: selectedSheet.dataSourceID,
        });
      }
    } else {
      console.error("workbook data is undefined");
    }
  }, [sheetId, workbookData]); // Add necessary dependencies

  const handleEditWorkbook = () => {
    console.log(workbookData);
    sessionStorage.setItem("workBookId", workbookData.draftId);
    // navigate("/workbook");
    console.log(workbookData.draftId);
    navigate(`/workbook?workbookid=${workbookData.draftId}&tutorial=true`);
  };

  const updateDimensions = () => {
    if (droppableAreaRef.current) {
      const droppableWidth =
        droppableAreaRef.current.getBoundingClientRect().width;
      setGridSize(droppableWidth / GRID_COLUMNS);
    }
  };

  useEffect(() => {
    updateDimensions(); // Initial dimensions
    window.addEventListener("resize", updateDimensions);

    return () => {
      window.removeEventListener("resize", updateDimensions);
    };
  }, [currentSheet, filterSideBar]); // Remove unnecessary dependencies

  //this will only run when currentSheet is null
  // useEffect(() => {
  //   if (workbookData && currentSheet === null) {
  //     console.log("currentSheet is null");
  //     const workbookid = workbookData["_id"];
  //     const sheetid = workbookData["sheets"][0]["ID"]
  //     const indexZeroSheet = workbookData["sheets"][0];
  //     setCurrentSheet({
  //       Sheetid: indexZeroSheet.ID,
  //       SheetName: indexZeroSheet.SheetName,
  //       SheetType: indexZeroSheet.sheetType,
  //       SheetVizType: indexZeroSheet.VizType,
  //       SheetDataSourceID: indexZeroSheet.dataSourceID,
  //     });
  //     // navigate(`/dasboard?workbookid=${workbookid}&sheetid=${sheetid}`);
  //   }
  //   console.log("currentSheet is not null");
  // }, [currentSheet]);

  if (isWorkbookLoading) {
    return <LoadingIndicator />;
  }
  if (isWorkbookError) {
    console.error(workbookError);
    return (
      <div className="flex items-center justify-start gap-1 text-red-500 text-xl">
        Error: {workbookError.data.error}
      </div>
    );
  }
  console.log(roles.includes("Guest"));

  return isWorkbookSuccess && currentSheet !== null ? (
    <>
      <main className="overscroll-hidden w-full h-screen">
        {/* header */}
        <section className="flex items-center justify-between px-3 border-b-2 rounded py-2 z-10 h-[7%]">
          <div className="flex items-center justify-center gap-2">
            <button
              className="flex items-center justify-start gap-1"
              onClick={() => navigate("/home/dash")}
            >
              <ImHome />
            </button>
            <LibraryFolderPaths isFolderPresentInLibrary={false} />
          </div>
          <div className="font-medium tracking-wide">{workbookData.name}</div>
          <div className="flex items-center justify-center gap-3">
            <button
              className="border border-blue-950 rounded px-5 text-[13px] py-1 text-blue-950"
              onClick={() => setSubscribeModal(true)}
            >
              Subscribe
            </button>
            {isEditButtonVisible ? (
              <button
                className="border border-blue-950 rounded px-5 text-[13px] py-1 text-blue-950"
                onClick={handleEditWorkbook}
              >
                Edit
              </button>
            ) : null}
            <button
              className="border border-blue-950 rounded px-5 text-[13px] py-1 bg-blue-950 text-white"
              onClick={() => {
                currentSheet.SheetType === "dashboard"
                  ? handleDownloadDataModal(sheetId)
                  : handleCallFunction(sheetId);
              }}
            >
              Download
            </button>
            <DropDownComp />
          </div>
        </section>

        {/* header 2 */}
        <ViewworkbookHeader2
          workbookData={workbookData}
          workbookId={workbookId}
          sheetId={sheetId}
          isPublicDashboardTrue={roles.includes("Guest")}
        />

        {/* charts of view workbook */}
        <ViewWBCharts
          droppableAreaRef={droppableAreaRef}
          gridSize={gridSize}
          currentSheet={currentSheet}
          itemRef={itemRef}
          snapToGrid={snapToGrid}
          buttonRef={buttonRef}
          setFilterSideBar={setFilterSideBar}
          filterSideBar={filterSideBar}
          sheetId={sheetId}
        />
      </main>

      {/* Subscribe Modal */}
      {subscribeModal && (
        <SubscribeModal closeModal={() => setSubscribeModal(false)} />
      )}
      {/* Download Data Modal */}
      {workbookData !== undefined && downloadDataModal && (
        <DownloadDataModal
          closeModal={() => setDownloadDataModal(false)}
          workbookData={workbookData}
          sheetId={sheetId}
        />
      )}
    </>
  ) : (
    <button
      className="flex items-center justify-start gap-1 text-red-500 text-xl"
      onClick={() => navigate(-1)}
    >
      <IoArrowBackOutline />
      Sheet Doesn't Exist
    </button>
  );
}
